import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ProviderInfoApi from '../../../API/provider/providerInfo-api';
import { addProviders } from '../../../actions/providers';
import { Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { Select } from '../../../components/Basic/Inputs';
import { TYPE_BUTTONS } from '../../../constans';
import StocksUpdateTable from './Table';

// 28 - Perfeo
// 3 - Ritmix
// 5 - Merlion
// 6 - PcShop
// 7 - Nix
// 11 - Kosmart
// 12 - KDV Яшкино
// 13 - Гала-центр
// 14 - Kristaller
// 15 - Prime sport (пока скрываем)
// 16 - Novasport
// 18 - магазин
// 20 - 18+
// 21 - 4fresh
// 23 - rustrus
// 25 - Сладрус
// 15 - Мир Красок
// 17 - Наша игрушка
// 18 - Люмна
// 40 - 18+
// 21 - Восток
// 23 - NatureVector
// 22 - SweetOpt
// 4 - Merlion
// 34 - Маркер Игрушки

// 34 - complexBar
// 34 - ETM

const WAREHOUSE_LIST = [
  { warehouse: 'Москва', name: 'msk' },
  { warehouse: 'Екатеринбург', name: 'ekb' },
];

const MARKETS_ALL = ['Ozon', 'Wildberries', 'ЯндексМаркет'];
const STATE = ['Остатки', 'Цена'];

const MARKETS_MAP = {
  Ozon: 'ozon',
  Wildberries: 'wb',
  ЯндексМаркет: 'yandex',
};
function StocksUpdatePage() {
  const dispatch = useDispatch();
  const [state, setState] = useState(STATE[0]);
  const [providers, setProviders] = useState([]);
  const allProviders = useSelector((store) => store.providers);
  const user = useSelector((store) => store.user);
  const [market, setMarket] = useState(MARKETS_ALL[0]);
  const [warehouse, setWarehouse] = useState(WAREHOUSE_LIST[0]);
  const [mode, setMode] = useState('Ручной');

  // список поставщиков
  useEffect(() => {
    const p = allProviders.filter((item) => !item.hide_update);
    if (p.length > 0) {
      setProviders(p);
    }
  }, [allProviders]);

  const access = user.role === 'owner' || user.role === 'admin';

  let updateStatuses = () => {
    ProviderInfoApi.getAll({}).then(r => dispatch(addProviders(r.providers)))
  };

  let updateStatistic = () => {
    ProviderInfoApi.formStat({ data: { market: MARKETS_MAP[market] } })
  };


  return (
    <Content>
      <WhiteBlock title="Площадка" title_bold={market} style={{ minWidth: '500px' }}>
        <Row style={{ alignItems: 'flex-end', marginBottom: '10px' }}>
          <Select list={MARKETS_ALL} select={market} label="Площадка" width={'150px'} onSelect={(m) => setMarket(m)} />

          <Select
            label="Обновление"
            select={state}
            width={'100px'}
            list={STATE}
            onSelect={(v) => setState(v)}
            style={{ marginLeft: '15px', marginRight: '15px' }}
          />
          <Select
            label="Склад"
            select={warehouse}
            valueFn={(v) => v.warehouse}
            width={'150px'}
            list={WAREHOUSE_LIST}
            onSelect={(v) => setWarehouse(v)}
            style={{ marginLeft: '15px', marginRight: '15px' }}
          />
          <Select
            label="Режим обновления"
            select={mode}
            width={'150px'}
            list={['Ручной', 'Авто']}
            onSelect={(v) => setMode(v)}
            style={{ marginLeft: '15px', marginRight: '15px' }}
          />
          <Button
            style={{ marginLeft: '15px', marginRight: '15px' }}
            type={TYPE_BUTTONS.GREEN}
            onClick={updateStatuses}
          >
            Обновить данные
          </Button>
          <Button
            style={{ marginLeft: '15px', marginRight: '15px' }}
            type={TYPE_BUTTONS.BLUE}
            onClick={updateStatistic}
          >
            Сформировать статистику
          </Button>
          <Button
            type={TYPE_BUTTONS.WHITE}
            onClick={() => ProviderInfoApi.excelStat({ data: { market: MARKETS_MAP[market] } })}
            style={{ marginRight: '15px' }}
          >
            Скачать статистику
          </Button>
        </Row>
      </WhiteBlock>
      <StocksUpdateTable
        providers={providers}
        market={market}
        state={state}
        skladName={warehouse.name}
        mode={mode}
        updateStatuses={updateStatuses}
      />
    </Content>
  );
}

export default StocksUpdatePage;
